import { IEmploymentRoleResponse } from './../types/employment-role';
import { IQualificationResponse } from '../types/qualification';
import { promises } from 'dns';
import EmploymentRolesMockResponse from '../testing/mocks/apiResponse/employmentRoles';

export interface ISkillsService {
  getQualifications(): Promise<IQualificationResponse>;
  getEmploymentRoles(): Promise<IEmploymentRoleResponse>;
}
interface IInputs {
  baseUrl: string;
}

export class SkillsService implements ISkillsService {
  baseUrl: string;

  constructor({ baseUrl }: IInputs) {
    this.baseUrl = baseUrl;
  }

  async getQualifications(): Promise<IQualificationResponse> {
    const res = await fetch(`${this.baseUrl}api/v1/qualifications`, {
      method: 'GET',
      headers: new Headers({
        Accept: 'application/json'
      })
    });
    return await res.json();
  }

  async getEmploymentRoles(): Promise<IEmploymentRoleResponse> {
    const res = await fetch(`${this.baseUrl}api/v1/EmploymentRoles`, {
      method: 'GET',
      headers: new Headers({
        Accept: 'application/json'
      })
    });
    return await res.json();
  }
}
